import Reveal from "./Reveal";
import { ShieldCheck, Wand2, Leaf, Award } from "lucide-react";

const features = [
  {
    icon: ShieldCheck,
    title: "Reliability",
    desc: "Guaranteed on-time delivery with consistent quality — because your schedule is our schedule.",
  },
  {
    icon: Wand2,
    title: "Bespoke Enchantments",
    desc: "Custom concrete mixes designed to meet your specific project requirements precisely.",
  },
  {
    icon: Leaf,
    title: "A Glimmer of Sustainability",
    desc: "Eco-friendly production with advanced waste reduction techniques and grey water recycling.",
  },
  {
    icon: Award,
    title: "Experience",
    desc: "Over 12 years of industry expertise — standing as your esteemed ally in the RMC realm.",
  },
];

const WhyChooseUs = () => (
  <section className="w-full bg-white py-12 md:py-16 lg:py-20 px-4 md:px-10 lg:px-16">
    <div className="max-w-7xl mx-auto">
      {/* Section Header */}
      <Reveal className="text-center mb-10 md:mb-12">
        <span className="text-xs font-semibold tracking-[0.25em] uppercase text-[#B3129E]">
          [ WHY CHOOSE US ]
        </span>

        <h2 className="text-2xl md:text-3xl lg:text-4xl xl:text-5xl tracking-wider text-[#041122] font-semibold font-heading leading-relaxed mt-3">
          The Mix Masters Difference
        </h2>
      </Reveal>

      <div className="flex flex-col lg:flex-row gap-8 lg:gap-10 items-stretch">
        {/* Feature Grid */}
        <div className="flex-1 grid grid-cols-1 sm:grid-cols-2 gap-4">
          {features.map((f, i) => {
            const Icon = f.icon;

            return (
              <Reveal key={f.title} delay={i * 80}>
                <div
                  className="rounded-2xl p-5 md:p-6 h-full border border-[#ebebeb] bg-[#f7f7f9] transition-all duration-200 cursor-default"
                  onMouseEnter={(e) => {
                    e.currentTarget.style.background = "#fdf0ff";
                    e.currentTarget.style.borderColor = "#e8b0f8";
                    e.currentTarget.style.transform = "translateY(-3px)";
                    e.currentTarget.style.boxShadow =
                      "0 8px 28px rgba(179,18,158,0.12)";
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.background = "#f7f7f9";
                    e.currentTarget.style.borderColor = "#ebebeb";
                    e.currentTarget.style.transform = "translateY(0)";
                    e.currentTarget.style.boxShadow = "none";
                  }}
                >
                  {/* Icon */}
                  <div className="w-10 h-10 rounded-xl flex items-center justify-center mb-4 bg-gradient-to-br from-[#B3129E] to-[#8F0F7D]">
                    <Icon size={18} className="text-white" strokeWidth={2} />
                  </div>

                  <h3 className="font-bold text-[#041122] text-sm mb-2">
                    {f.title}
                  </h3>

                  <p className="text-descriptionText text-xs leading-relaxed">
                    {f.desc}
                  </p>
                </div>
              </Reveal>
            );
          })}
        </div>

        {/* Right Visual Panel */}
        <Reveal delay={200} className="w-full lg:w-[420px] flex-shrink-0">
          <div className="rounded-3xl overflow-hidden h-full relative min-h-[320px] bg-gradient-to-br from-[#041122] via-[#2a0535] to-[#B3129E]">
            {/* decorative pattern */}
            <div
              className="absolute inset-0 opacity-10"
              style={{
                backgroundImage:
                  "radial-gradient(circle, #B3129E 1px, transparent 1px)",
                backgroundSize: "24px 24px",
              }}
            />

            <div className="absolute inset-0 flex flex-col items-center justify-center p-8 text-center">
              <p className="font-bebas text-[#B3129E] leading-none mb-1 text-[clamp(3rem,6vw,5rem)]">
                12+
              </p>

              <p className="text-white font-heading text-lg font-semibold mb-4">
                Years of Trust
              </p>

              <div className="w-12 h-1 bg-[#B3129E] mx-auto mb-6 rounded-full" />

              <p className="text-gray-300 text-sm leading-relaxed max-w-xs">
                From Bhubaneswar to across Odisha — delivering
                precision-engineered concrete that stands the test of time.
              </p>

              {/* Tags */}
              <div className="mt-8 flex flex-wrap gap-2 justify-center">
                {["AI Batching", "IoT Tracking", "ERP Enabled"].map((tag) => (
                  <span
                    key={tag}
                    className="text-xs rounded-full px-3 py-1 font-medium border border-[#B3129E44] bg-[#B3129E22] text-[#e8a0f0]"
                  >
                    {tag}
                  </span>
                ))}
              </div>
            </div>
          </div>
        </Reveal>
      </div>
    </div>
  </section>
);

export default WhyChooseUs;
// import Reveal from "./Reveal";
// const features = [
//   {
//     title: "Reliability",
//     desc: "Guaranteed on-time delivery with consistent quality — because your schedule is our schedule.",
//   },
//   {
//     title: "Bespoke Enchantments",
//     desc: "Custom concrete mixes designed to meet your specific project requirements precisely.",
//   },
//   {
//     title: "A Glimmer of Sustainability",
//     desc: "Eco-friendly production with advanced waste reduction techniques and grey water recycling.",
//   },
//   {
//     title: "Experience",
//     desc: "Over 12 years of industry expertise — standing as your esteemed ally in the RMC realm.",
//   },
// ];
// const WhyChooseUs = () => (
//   <section className="w-full bg-white py-16 md:py-24 px-6 md:px-10 lg:px-16">
//     <div className="max-w-7xl mx-auto">
//       <Reveal className="text-center mb-12">
//         <span className="text-xs font-semibold tracking-[0.25em] uppercase text-[#B3129E]">
//           [ WHY CHOOSE US ]
//         </span>
//         <h2
//           className="font-heading font-semibold text-headingText mt-3 leading-snug"
//           style={{ fontSize: "clamp(1.6rem,3.5vw,2.8rem)" }}
//         >
//           The Mix Masters Difference
//         </h2>
//       </Reveal>

//       <div className="flex flex-col lg:flex-row gap-8 items-stretch">
//         {/* feature grid */}
//         <div className="flex-1 grid grid-cols-1 sm:grid-cols-2 gap-4">
//           {features.map((f, i) => (
//             <Reveal key={f.title} delay={i * 100}>
//               <div
//                 className="rounded-2xl p-6 h-full border border-[#ebebeb] bg-[#f7f7f9] cursor-default"
//                 style={{ transition: "all 0.2s ease" }}
//                 onMouseEnter={(e) => {
//                   e.currentTarget.style.background = "#fdf0ff";
//                   e.currentTarget.style.borderColor = "#e8b0f8";
//                   e.currentTarget.style.transform = "translateY(-3px)";
//                   e.currentTarget.style.boxShadow =
//                     "0 8px 28px rgba(179,18,158,0.12)";
//                 }}
//                 onMouseLeave={(e) => {
//                   e.currentTarget.style.background = "#f7f7f9";
//                   e.currentTarget.style.borderColor = "#ebebeb";
//                   e.currentTarget.style.transform = "translateY(0)";
//                   e.currentTarget.style.boxShadow = "none";
//                 }}
//               >
//                 <div
//                   className="w-10 h-10 rounded-xl flex items-center justify-center mb-4"
//                   style={{
//                     background: "linear-gradient(135deg,#B3129E,#8F0F7D)",
//                   }}
//                 >
//                   <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
//                     <path
//                       d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"
//                       stroke="white"
//                       strokeWidth="1.8"
//                       fill="none"
//                       strokeLinejoin="round"
//                     />
//                   </svg>
//                 </div>
//                 <h3 className="font-bold text-headingText mb-2 text-sm">
//                   {f.title}
//                 </h3>
//                 <p className="text-descriptionText text-xs leading-relaxed">
//                   {f.desc}
//                 </p>
//               </div>
//             </Reveal>
//           ))}
//         </div>

//         {/* visual panel */}
//         <Reveal delay={200} className="w-full lg:w-[420px] flex-shrink-0">
//           <div
//             className="rounded-3xl overflow-hidden h-full relative"
//             style={{
//               minHeight: 320,
//               background:
//                 "linear-gradient(160deg,#041122 0%,#2a0535 50%,#B3129E 100%)",
//             }}
//           >
//             {/* decorative pattern */}
//             <div
//               className="absolute inset-0 opacity-10"
//               style={{
//                 backgroundImage:
//                   "radial-gradient(circle, #B3129E 1px, transparent 1px)",
//                 backgroundSize: "24px 24px",
//               }}
//             />
//             <div className="absolute inset-0 flex flex-col items-center justify-center p-8">
//               <div className="text-center">
//                 <p
//                   className="font-bebas text-[#B3129E] leading-none mb-1"
//                   style={{ fontSize: "clamp(3rem,6vw,5rem)" }}
//                 >
//                   12+
//                 </p>
//                 <p className="text-white font-heading text-lg font-semibold mb-4">
//                   Years of Trust
//                 </p>
//                 <div className="w-12 h-1 bg-[#B3129E] mx-auto mb-6 rounded-full" />
//                 <p className="text-gray-300 text-sm leading-relaxed text-center max-w-xs">
//                   From Bhubaneswar to across Odisha — delivering
//                   precision-engineered concrete that stands the test of time.
//                 </p>
//               </div>
//               {/* partner logos placeholder pills */}
//               <div className="mt-8 flex flex-wrap gap-2 justify-center">
//                 {["QCI Certified", "RMC Certified", "ISO 9000"].map((tag) => (
//                   <span
//                     key={tag}
//                     className="text-xs rounded-full px-3 py-1 font-medium"
//                     style={{
//                       background: "#B3129E22",
//                       color: "#e8a0f0",
//                       border: "1px solid #B3129E44",
//                     }}
//                   >
//                     {tag}
//                   </span>
//                 ))}
//               </div>
//             </div>
//           </div>
//         </Reveal>
//       </div>
//     </div>
//   </section>
// );

// export default WhyChooseUs
